import { LocalizationProvider, TimePicker as MuiDateTimePicker, TimePickerProps } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { DateTime } from 'luxon'
import React from 'react'

import { useComplatibleLocale, useRtlLocaleCheck } from '../../hooks'
import { createComponentWrapperWithRef, uiTokens } from '../../theme'

interface CustomTimePickerProps extends TimePickerProps<any> {
  locale?: string
}

const StyledDateTimePicker = createComponentWrapperWithRef(
  {
    mui: MuiDateTimePicker,
    nova: MuiDateTimePicker,
    novaProps: {
      sx: {
        '.MuiSvgIcon-root': {
          color: uiTokens.uiContent.accent,
        },
      },
    },
  },
  'StyledDateTimePicker',
) as typeof MuiDateTimePicker

export function TimePicker(props: CustomTimePickerProps) {
  const { locale = DateTime.local().locale, slotProps: slotPropsProp, ...rest } = props
  const compatibleLocale = useComplatibleLocale(locale)
  const isRtl = useRtlLocaleCheck(locale)

  const slotProps = {
    ...slotPropsProp,
    textField: {
      ...slotPropsProp?.textField,
      inputProps: {
        ...(slotPropsProp?.textField as Record<string, any>)?.inputProps,
        dir: isRtl ? 'rtl' : undefined,
      },
    },
  }

  const val = props.value === null || props.value === undefined || !props.value.isValid ? null : props.value

  const handleChange = (newValue: DateTime | null, context: any) => {
    if (!newValue || newValue.isValid) {
      rest.onChange?.(newValue, context)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={compatibleLocale}>
      <StyledDateTimePicker {...rest} slotProps={slotProps} value={val} onChange={handleChange} />
    </LocalizationProvider>
  )
}
